// Палитра раздела рассылок. Раскладка взята из макета платформы, а цвета —
// как в остальной системе: светлая тема Material-UI (индиго).
//
// Цвета здесь это переменные CSS (`var(--wa-…)`), а значения светлой и тёмной тем лежат ниже:
// оболочка раздела включает нужный набор, и все экраны меняются сами, ни один компонент не
// знает, какая тема сейчас.

const light = {
  // Фон страницы и панелей
  bg: '#fafafa',
  panel: '#ffffff',
  panelAlt: '#f5f5f5',
  border: '#e0e0e0',

  // Основной акцент — тот же индиго, что у AppBar в остальной системе
  accent: '#3f51b5',
  accentSoft: '#e8eaf6',
  accentHover: '#303f9f',

  // Цвета рядов графика и плиток
  green: '#4caf50',
  blue: '#2196f3',
  red: '#f44336',

  // Текст — как в дефолтной теме MUI
  text: 'rgba(0, 0, 0, 0.87)',
  textDim: 'rgba(0, 0, 0, 0.54)',
  textFaint: 'rgba(0, 0, 0, 0.38)',

  // Подложки статусов
  okBg: '#e8f5e9',
  okText: '#1b5e20',
  warnBg: '#fff8e1',
  warnText: '#8d6e00',
  dangerText: '#c62828',
  mutedBg: '#eceff1',
  mutedText: '#455a64',
};

// Тёмная тема: серые, а не чёрные поверхности, приглушённый индиго (белый текст на нём
// читается), статусы с прозрачной подложкой.
const dark = {
  bg: '#121212',
  panel: '#1e1e1e',
  panelAlt: '#2a2a2a',
  border: '#3a3a3a',

  accent: '#6573c3',
  accentSoft: 'rgba(121, 134, 203, 0.2)',
  accentHover: '#7986cb',

  green: '#66bb6a',
  blue: '#42a5f5',
  red: '#ef5350',

  text: 'rgba(255, 255, 255, 0.92)',
  textDim: 'rgba(255, 255, 255, 0.66)',
  textFaint: 'rgba(255, 255, 255, 0.46)',

  okBg: 'rgba(76, 175, 80, 0.2)',
  okText: '#81c784',
  warnBg: 'rgba(255, 193, 7, 0.16)',
  warnText: '#ffd54f',
  dangerText: '#ff8a80',
  mutedBg: '#2c3338',
  mutedText: '#b0bec5',
};

const name = (key) => `--wa-${key.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)}`;
const variables = (palette) =>
  Object.keys(palette).reduce((all, key) => ({ ...all, [name(key)]: palette[key] }), {});

export const lightVariables = variables(light);
export const darkVariables = variables(dark);

// То, что используют компоненты: `colors.text` это `var(--wa-text)`.
export const colors = Object.keys(light).reduce(
  (all, key) => ({ ...all, [key]: `var(${name(key)})` }),
  {}
);

// Цвета для MUI (палитра темы): ей нужны настоящие значения, не переменные.
export const palettes = { light, dark };

export default colors;
